'use strict';

import GenericTableData from './GenericTableData';

let ServiceContractTransactionsData = GenericTableData.getTableDataBus(
  'SC_TRANS',
  'service_contract_transactions',
);

ServiceContractTransactionsData.deleteServiceContractTransaction = (
  transId,
) => {
  return ServiceContractTransactionsData.deleteRecordsWhere({
    transaction_id: transId,
  });
};
export default ServiceContractTransactionsData;
